import React, { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { AppRoute } from '../routes.types';
import { USER_ROLES } from '../../utils/constants';

const AdminMarketplace = lazy(() => import('../../containers/AdminMarketplace/AdminMarketplace'));
const TimelineEditor = lazy(() => import('../../containers/AdminMarketplace/TimelinePage/TimelineEditor'));
const LandscapeMapDemoPage = lazy(() => import('../../containers/LandscapeMapContainer/LandscapeMapDemo'));
const MarketplaceTemplatePreview = lazy(() => import('../../containers/AdminMarketplace/MarketplaceTemplatePreview/MarketplaceTemplatePreview'));
const ConnectMarketplaceDashboard = lazy(() => import('../../containers/ConnectMarketplaceDashboard/ConnectMarketplaceDashboard'));
const DataAndDocumentTemplatesDashboard = lazy(() =>
    import('../../containers/Admin/DataRequest/DataAndDocumentTemplatesDashboard/DataAndDocumentTemplatesDashboard')
        .then((m) => ({ default: m.DataAndDocumentTemplatesDashboard }))
);
const DataAndDocumentRequestsDashboard = lazy(() =>
    import('../../containers/Admin/DataRequest/DataAndDocumentRequestsDashboard/DataAndDocumentRequestsDashboard')
        .then((m) => ({ default: m.DataAndDocumentRequestsDashboard }))
);
const ProjectEditorHost = lazy(() =>
    import('../../containers/Admin/DataRequest/ProjectEditorHost/ProjectEditorHost')
        .then((m) => ({ default: m.ProjectEditorHost }))
);
const Controls = lazy(() => import('../../containers/Admin/Controls/Controls'));
const ChartImage = lazy(() => import('../../containers/Admin/chart-image'));
const PricingComponent = lazy(() => import('../../containers/Admin/Pricing/PricingComponent'));
const PaidReportFromUpdates = lazy(() => import('../../containers/Admin/PaidReportFromUpdates'));
const KnowledgeBaseContentManager = lazy(() => import('../../containers/KnowledgeBase/KnowledgeBaseContentManager/KnowledgeBaseContentManager'));
const SupportPortalPage = lazy(() => import('../../containers/SupportRequestsPage/SupportRequestsPage'));
const AdminNotificationSettingsPage = lazy(() => import('../../containers/AdminNotificationSettingsPage/AdminNotificationSettingsPage'));
const LegalDocumentsManager = lazy(() =>
    import('../../containers/Admin/LegalDocuments/LegalDocumentsManager')
        .then((m) => ({ default: m.LegalDocumentsManager }))
);
const PracticeManagementGroupsAdmin = lazy(() => import('../../containers/PracticeManagementGroups/PracticeManagementAdmin'));
const CorporateGroupManagementAdmin = lazy(() => import('../../containers/CorporateGroupManagement/CorporateGroupManagementAdmin'));
const MaintenanceTool = lazy(() =>
    import('../../containers/Maintenance/MaintenanceTool').then((m) => ({ default: m.MaintenanceTool }))
);
const TimelineSimulator = lazy(() =>
    import('../../containers/Maintenance/TimelineSimulator').then((m) => ({ default: m.TimelineSimulator }))
);
const ClientErrorReports = lazy(() =>
    import('../../containers/Maintenance/ClientErrorReports').then((m) => ({ default: m.ClientErrorReports }))
);
const QuartzMonitor = lazy(() =>
    import('../../containers/Maintenance/QuartzMonitor/QuartzMonitor').then((m) => ({ default: m.QuartzMonitor }))
);
const PracticeList = lazy(() => import('../../containers/Practices/Admin/PracticeList'));

export const ADMIN_ROUTES: AppRoute[] = [
    {
        path: '/admin',
        element: <Outlet />,
        roles: [USER_ROLES.ADMIN],
        withAppShell: true,
        children: [
            { path: 'controls', element: <Controls /> },
            { path: 'upload-chart', element: <ChartImage /> },
            { path: 'pricing', element: <PricingComponent /> },
            { path: 'paidreport-from-updates', element: <PaidReportFromUpdates /> },
            { path: 'knowledge-library', element: <KnowledgeBaseContentManager /> },
            { path: 'support-requests', element: <SupportPortalPage /> },
            { path: 'notifications', element: <AdminNotificationSettingsPage /> },
            { path: 'legal-documents', element: <LegalDocumentsManager /> },
        ],
    },
    { path: '/pmg-admin', element: <PracticeManagementGroupsAdmin />, roles: [USER_ROLES.ADMIN] },
    { path: '/cgm-admin', element: <CorporateGroupManagementAdmin />, roles: [USER_ROLES.ADMIN] },
    { path: '/marketplace/admin', element: <AdminMarketplace />, roles: [USER_ROLES.ADMIN] },
    { path: '/marketplace/admin/engagement/:engagementId', element: <ConnectMarketplaceDashboard />, roles: [USER_ROLES.ADMIN] },
    { path: '/marketplace/admin/templates/:id', element: <TimelineEditor type="template" />, roles: [USER_ROLES.ADMIN] },
    { path: '/marketplace/admin/engagements/:id', element: <TimelineEditor type="engagement" />, roles: [USER_ROLES.ADMIN] },
    { path: '/marketplace/admin/templates/:id/preview', element: <MarketplaceTemplatePreview type="template" />, roles: [USER_ROLES.ADMIN] },
    { path: '/landscapemap/admin', element: <LandscapeMapDemoPage />, roles: [USER_ROLES.ADMIN] },
    { path: '/maintenance-tool', element: <MaintenanceTool />, roles: [USER_ROLES.ADMIN] },
    { path: '/maintenance-tool/timeline-simulator', element: <TimelineSimulator />, roles: [USER_ROLES.ADMIN] },
    { path: '/maintenance-tool/client-errors', element: <ClientErrorReports />, roles: [USER_ROLES.ADMIN] },
    { path: '/maintenance-tool/quartz-monitor', element: <QuartzMonitor />, roles: [USER_ROLES.ADMIN] },
    { path: '/practice-list', element: <PracticeList />, withAppShell: true, roles: [USER_ROLES.ADMIN] },
    { path: '/data-and-document-templates-dashboard', element: <DataAndDocumentTemplatesDashboard />, withAppShell: true, roles: [USER_ROLES.ADMIN] },
    { path: '/data-and-document-requests-dashboard', element: <DataAndDocumentRequestsDashboard />, withAppShell: true, roles: [USER_ROLES.ADMIN] },
    { path: '/project-editor', element: <ProjectEditorHost />, withAppShell: true, roles: [USER_ROLES.ADMIN] },
];
